const Pagination = ({ currentPage, totalPages, handlePaginationClick, handlePreviousPage, handleNextPage }) => {

    const getPageNumbers = () => {
      const pages = [];
  
      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
        return pages;
      }
  
      pages.push(1);
  
      if (currentPage > 3) {
        pages.push("...");
      }
  
      const start = Math.max(2, currentPage - 1);
      const end = Math.min(totalPages - 1, currentPage + 1);
  
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
  
      if (currentPage < totalPages - 2) {
        pages.push("...");
      }
  
      pages.push(totalPages);
  
      return pages;
    };
  
    return (
      <div className="custom_pagenation mt-4 mb-4">
        <ul className="d-flex align-items-center justify-content-center">
  
          {totalPages > 5 && (
            <li className={`circle ${currentPage === 1 ? 'disabled' : ''}`}>
              <button
                className="btn text-purple font-w"
                onClick={handlePreviousPage}
                disabled={currentPage === 1}
              >
                Pre
              </button>
            </li>
          )}
  
          {getPageNumbers().map((page, index) =>
            page === "..." ? (
              <li key={index} className="circle dots">
                <span className="text-purple font-w">...</span>
              </li>
            ) : (
              <li
                key={index}
                className={`circle ${page === currentPage ? 'active' : ''}`}
                onClick={() => handlePaginationClick(page)}
              >
                <button className="btn text-purple font-w">
                  {page}
                </button>
              </li>
            )
          )}
  
          {totalPages > 5 && (
            <li className={`circle ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button
                className="btn text-purple font-w"
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </li>
          )}
  
        </ul>
      </div>
    );
  };
  
export default Pagination;  